import React from 'react';

import { isFinite } from 'lodash';

import './ListingInfoBoxStyle.less';

export interface IListingInfoBoxProps {
  imgSrc: string;
  listingStatus: string;
  livingArea: number;
  lotSize: number;
  numBaths: number;
  numBeds: number;
  readableAddress: string;
}

const formatNumber = (num: number, decimals: number): string => {
  return isFinite(num) ? num.toLocaleString('en', { minimumFractionDigits: decimals }) : '-';
};

const ListingInfoBox: React.SFC<IListingInfoBoxProps> = (props: IListingInfoBoxProps) => {
  const { imgSrc, listingStatus, livingArea, lotSize, numBaths, numBeds, readableAddress } = props;

  return (
    <div className="od-listing-info-box">
      <div className="img-wrapper">
        <img src={imgSrc} />
      </div>
      <div className="listing-details">
        <h5>{readableAddress}</h5>
        <p className="text-bold">
          <span className="text-capitalize">{listingStatus}</span> •&nbsp;
          {numBeds} bed • {numBaths} bath •&nbsp;
          {formatNumber(livingArea, 0)} ft
          <sup>2</sup> •&nbsp;
          {formatNumber(lotSize, 0)} ft
          <sup>2</sup> lot
        </p>
      </div>
    </div>
  );
};

export default ListingInfoBox;
